<template>
  <nav :class="['navbar navbar-expand-lg bg-black p-0', { sticky: isSticky }]">
    <div class="container mw-1720 bg-white px-50 position-relative">
      <RouterLink class="navbar-brand" to="/">
        <img
          src="@/assets/images/logo.svg"
          class="main-logo"
          alt="white-logo"
        />
        <img
          src="@/assets/images/white-logo.svg"
          class="white-logo d-none"
          alt="white-logo"
        />
      </RouterLink>
      <a class="navbar-toggler" @click="stateStoreInstance.responsiveNavbar">
        <span class="burger-menu">
          <span class="top-bar"></span>
          <span class="middle-bar"></span>
          <span class="bottom-bar"></span>
        </span>
      </a>

      <div class="collapse navbar-collapse">
        <ul class="navbar-nav ms-auto">
          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              href="#"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              الرئيسية
            </a>

            <ul class="dropdown-menu">
              <li>
                <RouterLink class="dropdown-item" to="/">
                  مزود خدمة الإنترنت (ISP)
                </RouterLink>
              </li>
              <li>
                <RouterLink class="dropdown-item" to="/iptv-service">
                  خدمة IPTV
                </RouterLink>
              </li>
              <li>
                <RouterLink class="dropdown-item" to="/isp-broadband">
                  إنترنت النطاق العريض (Broadband)
                </RouterLink>
              </li>
              <li>
                <RouterLink class="dropdown-item" to="/ott-platform">
                  منصة OTT
                </RouterLink>
              </li>
              <li>
                <RouterLink class="dropdown-item" to="/movie-home">
                  رئيسية الأفلام
                </RouterLink>
              </li>
              <li>
                <RouterLink class="dropdown-item" to="/satellite-internet">
                  الإنترنت الفضائي
                </RouterLink>
              </li>
            </ul>
          </li>

          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              href="#"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              الخدمات
            </a>

            <ul class="dropdown-menu">
              <li>
                <RouterLink class="dropdown-item" to="/services">
                  الخدمات
                </RouterLink>
              </li>
              <li>
                <RouterLink class="dropdown-item" to="/services-details">
                  تفاصيل الخدمات
                </RouterLink>
              </li>
            </ul>
          </li>

          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              href="#"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              الصفحات
            </a>

            <ul class="dropdown-menu">
              <li>
                <RouterLink class="dropdown-item" to="/about-us">
                  من نحن
                </RouterLink>
              </li>
              <li>
                <RouterLink class="dropdown-item" to="/testimonials">
                  آراء العملاء
                </RouterLink>
              </li>
              <li>
                <RouterLink class="dropdown-item" to="/pricing-plan">
                  خطة الأسعار
                </RouterLink>
              </li>
              <li>
                <RouterLink class="dropdown-item" to="/channel-list">
                  قائمة القنوات
                </RouterLink>
              </li>
              <li>
                <RouterLink class="dropdown-item" to="/faq"> الأسئلة الشائعة </RouterLink>
              </li>
              <li>
                <a
                  class="dropdown-item sub-dropdown dropdown-toggle"
                  href="#"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  التوثيق وتفعيل الحساب
                </a>

                <ul class="dropdown-menu">
                  <li>
                    <RouterLink class="dropdown-item" to="/login-register">
                      تسجيل الدخول / التسجيل
                    </RouterLink>
                  </li>
                  <li>
                    <RouterLink class="dropdown-item" to="/login">
                      تسجيل الدخول
                    </RouterLink>
                  </li>
                  <li>
                    <RouterLink class="dropdown-item" to="/register">
                      حساب جديد
                    </RouterLink>
                  </li>
                  <li>
                    <RouterLink class="dropdown-item" to="/change-password">
                      تغيير كلمة المرور
                    </RouterLink>
                  </li>
                  <li>
                    <RouterLink class="dropdown-item" to="/forgot-password">
                      نسيت كلمة المرور
                    </RouterLink>
                  </li>
                </ul>
              </li>
              <li>
                <RouterLink class="dropdown-item" to="/privacy-policy">
                  سياسة الخصوصية
                </RouterLink>
              </li>
              <li>
                <RouterLink class="dropdown-item" to="/terms-conditions">
                  الشروط والأحكام
                </RouterLink>
              </li>
            </ul>
          </li>

          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              href="#"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              المتجر
            </a>

            <ul class="dropdown-menu">
              <li>
                <RouterLink class="dropdown-item" to="/products">
                  المنتجات
                </RouterLink>
              </li>
              <li>
                <RouterLink class="dropdown-item" to="/product-details">
                  تفاصيل المنتج
                </RouterLink>
              </li>
              <li>
                <RouterLink class="dropdown-item" to="/cart"> سلة المشتريات </RouterLink>
              </li>
              <li>
                <RouterLink class="dropdown-item" to="/checkout">
                  إتمام الطلب
                </RouterLink>
              </li>
              <li>
                <RouterLink class="dropdown-item" to="/pay-bill">
                  دفع الفاتورة
                </RouterLink>
              </li>
              <li>
                <RouterLink class="dropdown-item" to="/pay-bill-pin">
                  رمز دفع الفاتورة (PIN)
                </RouterLink>
              </li>
            </ul>
          </li>

          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              href="#"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              المدونة
            </a>

            <ul class="dropdown-menu">
              <li>
                <RouterLink class="dropdown-item" to="/blog"> المدونة </RouterLink>
              </li>
              <li>
                <RouterLink class="dropdown-item" to="/blog-details">
                  تفاصيل المقال
                </RouterLink>
              </li>
              <li>
                <RouterLink class="dropdown-item" to="/tags"> الأوسام </RouterLink>
              </li>
              <li>
                <RouterLink class="dropdown-item" to="/categories">
                  التصنيفات
                </RouterLink>
              </li>
              <li>
                <RouterLink class="dropdown-item" to="/author">
                  الكاتب
                </RouterLink>
              </li>
            </ul>
          </li>

          <li class="nav-item dropdown">
            <RouterLink class="nav-link" to="/pricing-plan">
              خطة الأسعار
            </RouterLink>
          </li>

          <li class="nav-item dropdown">
            <RouterLink class="nav-link" to="/contact-us">
              اتصل بنا
            </RouterLink>
          </li>
        </ul>
      </div>

      <ul
        class="d-flex ps-0 mb-0 list-unstyled justify-content-end align-items-center others-options"
      >
        <li class="d-none d-sm-inline-block">
          <a href="tel:125487568" class="call icon">
            <i class="ti ti-phone-incoming"></i>
          </a>
        </li>
        <li>
          <a class="cart icon" @click="stateStoreInstance.cartModal">
            <i class="ti ti-shopping-cart"></i>
            <span>{{ cartStore.cartItemCount }}</span>
          </a>
        </li>
        <li>
          <a class="search icon" @click="stateStoreInstance.searchModal">
            <i class="ti ti-search"></i>
          </a>
        </li>
        <li class="d-xl-none">
          <RouterLink to="/register" class="search icon">
            <i class="ti ti-user"></i>
          </RouterLink>
        </li>
        <li class="d-none d-xl-block">
          <RouterLink to="/register" class="btn active">
            <span class="border-style">سجل الآن</span>
          </RouterLink>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import stateStore from "@/utils/store";
import { useCartStore } from "@/store/index";

export default defineComponent({
  name: "NavbarOne",
  setup() {
    const isSticky = ref(false);
    const stateStoreInstance = stateStore;
    const cartStore = useCartStore();

    onMounted(() => {
      window.addEventListener("scroll", () => {
        let scrollPos = window.scrollY;
        isSticky.value = scrollPos >= 100;
      });
    });

    return {
      isSticky,
      stateStoreInstance,
      cartStore,
    };
  },
});
</script>